import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Bm10060View from "../../Views/Bases/BM10060";
import Snackbar from "../../Components/Snackbar";

function BM10060() {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({});

  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [checkInputs, setCheckInputs] = React.useState({ result: false });
  const [checkInputs1, setCheckInputs1] = React.useState({ result: false });
  const [saveData, setSaveData] = React.useState({
    lcategoCd: "",
    mcategoCd: "",
    scategoCd: "",
    screenType: "",
    result: false,
  });
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let userInfo = null;

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10060.GetMenus,
        {
          lang: userInfo.lang,
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getRowData.push({
            lcategoCd: data[i].lcategoCd,
            mcategoCd: data[i].mcategoCd,
            scategoCd: data[i].scategoCd,
            lanName: data[i].lanName,
            screenType: data[i].screenType,
          });
        }
      });

      setRowData(getRowData);
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const CheckKeys = async () => {
    Dialog.ProgressBar(true);
    let getRowData = [];
    try {
      if (!checkInputs.lcategoCd) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_CheckLCategory" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      } else if (!checkInputs.mcategoCd) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_CheckMCategory" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      } else if (!checkInputs.scategoCd) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_CheckSCategory" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      } else if (!checkInputs.screenType) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_CheckMenuType" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10060.CheckCode,
        {
          lcategoCd: checkInputs.lcategoCd,
          mcategoCd: checkInputs.mcategoCd,
          scategoCd: checkInputs.scategoCd,
          screenType: checkInputs.screenType,
        }
      ).then((result) => {
        let data = result.data;
        if (data) {
          setCheckInputs({
            ...checkInputs,
            result: data,
          });
          getRowData.push({
            lcategoCd: checkInputs.lcategoCd,
            mcategoCd: checkInputs.mcategoCd,
            scategoCd: checkInputs.scategoCd,
            screenType: checkInputs.screenType,
          });
          setSaveData(getRowData);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setCheckInputs({
            ...checkInputs,
            lcategoCd: "",
            mcategoCd: "",
            scategoCd: "",
            screenType: "",
          });
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const CheckKeys1 = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    //let getRowData = [];
    try {
      if (!checkInputs1.detailCd) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) =>
              f.lanId === "Snack_CheckFunctionalCode" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10060.CheckCode1,
        {
          lcategoCd: selectedRowData[0].lcategoCd,
          mcategoCd: selectedRowData[0].mcategoCd,
          scategoCd: selectedRowData[0].scategoCd,
          detailCd: checkInputs1.detailCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data) {
          setCheckInputs1({
            ...checkInputs1,
            result: data,
          });
          // getRowData.push({
          //   lcategoCd: checkInputs.lcategoCd,
          //   mcategoCd: checkInputs.mcategoCd,
          //   scategoCd: checkInputs.scategoCd,
          //   screenType: checkInputs.screenType,
          //   detailCd: checkInputs1.detailCd,
          // });
          // setSaveData(getRowData);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setCheckInputs1({
            ...checkInputs,
            lcategoCd: "",
            mcategoCd: "",
            scategoCd: "",
            screenType: "",
            detailCd: "",
          });
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const SaveConfirm = (_grid) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic(_grid);
      }
    );
  };

  const SaveLogic = async (_grid) => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData1);
    let getSaveData = [];

    let tranData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (_grid == "grid1") {
        getSaveData.push({
          lcategoCd: selectedRowData[0].lcategoCd,
          mcategoCd: selectedRowData[0].mcategoCd,
          scategoCd: selectedRowData[0].scategoCd,
          detailCd: changedRowData1[0].detailCd,
          detailNm: changedRowData1[0].detailNm,
          createYn: changedRowData1[0].createYn == true ? "Y" : "N",
          deleteYn: changedRowData1[0].deleteYn == true ? "Y" : "N",
          readYn: changedRowData1[0].readYn == true ? "Y" : "N",
          pdfYn: changedRowData1[0].pdfYn == true ? "Y" : "N",
          excelYn: changedRowData1[0].excelYn == true ? "Y" : "N",
          updateYn: changedRowData1[0].updateYn == true ? "Y" : "N",
          printYn: changedRowData1[0].printYn == true ? "Y" : "N",
        });
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl +
            Global.urls.logic.Bases.BM10060.CreateMenusFuncs,
          getSaveData
        ).then((result) => {
          let data = result.data;

          if (data !== "Ok") {
            throw new Error(data.message);
          } else if (data.type === "Error") {
            throw new Error(data.message);
          } else {
            GetMenusDtl(
              selectedRowData[0].lcategoCd,
              selectedRowData[0].mcategoCd,
              selectedRowData[0].scategoCd
            );
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        });
      } else {
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl +
            Global.urls.logic.Bases.BM10060.CreateMenus,
          saveData
        ).then((result) => {
          let data = result.data;

          if (data !== "Ok") {
            throw new Error(data.message);
          } else if (data.type === "Error") {
            throw new Error(data.message);
          } else {
            Init();
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        });
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };

  const GetMenusDtl = async (_lcategoCd, _mcategoCd, _scategoCd) => {
    Dialog.ProgressBar(true);
    let getRowData = [];

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10060.GetMenusDtl,
        {
          lcategoCd: _lcategoCd,
          mcategoCd: _mcategoCd,
          scategoCd: _scategoCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              detailCd: data[i].detailCd,
              detailNm: data[i].detailNm,
              createYn: data[i].createYn == "Y" ? true : false,
              readYn: data[i].readYn == "Y" ? true : false,
              updateYn: data[i].updateYn == "Y" ? true : false,
              deleteYn: data[i].deleteYn == "Y" ? true : false,
              printYn: data[i].printYn == "Y" ? true : false,
              excelYn: data[i].excelYn == "Y" ? true : false,
              pdfYn: data[i].pdfYn == "Y" ? true : false,
              createDate: data[i].createDate
                ? Commons.DateFormating(data[i].createDate.toString(), 2)
                : "",
              createId: data[i].createId,
              updateDate: data[i].updateDate
                ? Commons.DateFormating(data[i].updateDate.toString(), 2)
                : "",
              updateId: data[i].updateId,
            });
            setRowData1(Commons.InsertNumber(getRowData));
          }
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <div>
      <Bm10060View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        GetMenusDtl={GetMenusDtl}
        inputs={inputs}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        checkInputs1={checkInputs1}
        setCheckInputs1={setCheckInputs1}
        setSelectedRowData={setSelectedRowData}
        setInputs={setInputs}
        CheckKeys={CheckKeys}
        CheckKeys1={CheckKeys1}
        SaveConfirm={SaveConfirm}
        changedRowData={changedRowData}
        changedRowData1={changedRowData1}
        setChangedRowData={setChangedRowData}
        setChangedRowData1={setChangedRowData1}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

export default BM10060;
